import { AddBusiness, Storefront } from '@mui/icons-material';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';

import useUserSection from 'hooks/useUserSection';
import { UsersTypes } from 'types/global';

type Props = {
	user: User;
	onPress: (user: User) => void;
};

function SectionButton({ user, onPress }: Props) {
	const { loading, section } = useUserSection(user.username);

	if (!([UsersTypes.barAdmin, UsersTypes.barPanel, UsersTypes.barCashier] as string[]).includes(user.type)) {
		return null;
	}

	const tooltip = loading ? 'Cargando...' : section ? section.title : 'Sector';

	return (
		<Tooltip title={tooltip}>
			<span>
				<IconButton onClick={() => onPress(user)} color={section ? 'secondary' : 'primary'} disabled={loading}>
					{loading && <CircularProgress size={20} />}
					{!loading && !section && <AddBusiness />}
					{!loading && !!section && <Storefront />}
				</IconButton>
			</span>
		</Tooltip>
	);
}

export default SectionButton;
